import { Box } from "@mui/material";
import asisstantApi from "api/assistantApi";
import React, { useEffect, useRef, useState } from "react";
import { Wrapper } from "./styles";
import HeaderBox from "components/HeaderBox";
import MessageBox from "components/MessageBox";
import SendMessageBox from "./SendMessageBox";
import ConversationItem from "./ConversationItem";
import { MESSAGE } from "constants";
import { ROLE } from "constants";

const Assistant = () => {
  const [isSending, setIsSending] = useState(false);
  const [message, setMessage] = useState({
    title: '',
    type: '',
    contents: []
  });
  const messagesEndRef = useRef(null);

  const [conversation, setConversation] = useState([
    { role: ROLE.ASSISTANT, content: "商品名・お客様名を入力してください。" }
  ]);


  // Effect to scroll to the bottom of chat messages
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }
  }, [conversation]);

  const handleSend = async (inputText) => {
    if (!inputText) return;
    try {
      setIsSending(true);
      const params = {
        message: inputText
      }

      setConversation(preVal => [...preVal, { role: ROLE.USER, content: inputText || '' }]);
      const { data } = await asisstantApi.sendQuestion(params);
      const msgContent = !!data?.dtRequest?.action || !!data?.dtRequest?.client_name || !!data?.dtRequest?.goods_name ? data?.content : 'すみません、依頼がわかりません。';
      const newConversationItem = {
        role: ROLE.ASSISTANT,
        content: msgContent,
        dtGoods: data?.dtGoods || [],
        dtClient: data?.dtClient || []
      }
      setConversation(preVal => [...preVal, newConversationItem]);
      setIsSending(false);
    } catch (err) {
      const errMsg = {
        type: MESSAGE.ERROR,
        contents: [err]
      }
      setMessage(errMsg);
      setIsSending(false);
    }
  }
  return (
    <Wrapper>
      <HeaderBox title='アシスタント' showCart />
      <MessageBox message={message} setMessage={setMessage} />
      <Box sx={{ height: "100%", overflowY: "scroll", paddingBottom: 16 }} ref={messagesEndRef}>
        {conversation.map((c, index) => (<ConversationItem key={index} item={c} />))}
        {!!isSending && <ConversationItem item={{ role: ROLE.ASSISTANT, content: "Loading...." }}></ConversationItem>}
        <div ref={messagesEndRef}></div>
      </Box>
      <SendMessageBox handleSend={handleSend} isSending={isSending} />
    </Wrapper>
  );
};

export default Assistant;
